// extracted by mini-css-extract-plugin
export default {"error-container":"Error_error-container__pCEC3"};